import { publicRegistry } from '@/i18n/dictionaries/publicRegistry';
import { useTranslation } from '@/i18n/useTranslation';
import type { AdvisorCoverageGapsProps } from '@/features/publicsite/types/registry/AdvisorCoverageGapsProps';

/**
 * ToR §6.3 "maparea acoperirii teritoriale": the zones no advisor covers, named directly — a
 * generic link to the interactive map could not tell a visitor which raions those are, only that
 * some pins were missing from a map they had to scan themselves.
 */
export function AdvisorCoverageGaps({ coverage }: AdvisorCoverageGapsProps) {
  const { t } = useTranslation(publicRegistry);
  return (
    <div className="advisors-coverage">
      {coverage.gapZones.length > 0 ? (
        // Collapsed by default: 36 chips open on every load pushed the search form a
        // screen down for a visitor who came to look up one adviser, not audit coverage.
        // <details> rather than the Dropdown used for the (editable) zone picker
        // elsewhere — nothing here is selected or changed, only shown.
        <details>
          <summary className="muted">
            {t('advisorsGapsLead', {
              count: coverage.gapZones.length,
              total: coverage.totalZones,
            })}
          </summary>
          <div className="chip-row advisors-coverage__chips">
            {coverage.gapZones.map((z) => (
              <span key={z.territorialUnitId} className="chip">
                {z.name}
              </span>
            ))}
          </div>
        </details>
      ) : (
        <p className="muted">{t('advisorsGapsNone')}</p>
      )}
    </div>
  );
}
